module.exports = __webpack_public_path__ + "img/bubble6.4702ccdc.svg";